/* JA Secure Solutions — light interaction layer.
   Everything here is progressive enhancement; the theme works without it. */
(function () {
  'use strict';

  /* Close the header mega panel / collection filter dropdowns when clicking outside. */
  document.addEventListener('click', function (event) {
    document.querySelectorAll('details.jas-mega[open], details.jas-filter[open]').forEach(function (mega) {
      if (!mega.contains(event.target)) mega.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details.jas-mega[open], details.jas-drawer[open], details.jas-filter[open]').forEach(function (d) {
      d.removeAttribute('open');
    });
  });

  /* Collection toolbar — filters and sort submit themselves, so hide the Apply button. */
  document.querySelectorAll('[data-jas-autosubmit]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });
  document.querySelectorAll('form [data-jas-apply]').forEach(function (button) {
    if (button.form && button.form.querySelector('[data-jas-autosubmit]')) button.hidden = true;
  });

  /* Lock body scroll while the mobile drawer is open. */
  document.querySelectorAll('details.jas-drawer').forEach(function (drawer) {
    drawer.addEventListener('toggle', function () {
      document.body.style.overflow = drawer.open ? 'hidden' : '';
    });
  });

  /* PDP gallery — thumb click swaps the main image; mobile rail updates bars. */
  document.querySelectorAll('[data-jas-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('.jas-gallery__main img');
    var counter = gallery.querySelector('[data-jas-counter]');
    var total = gallery.querySelectorAll('.jas-gallery__thumb').length;

    gallery.querySelectorAll('.jas-gallery__thumb').forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        var img = thumb.querySelector('img');
        if (!img) return;
        main.src = img.dataset.full || img.src;
        main.srcset = img.dataset.fullSrcset || '';
        main.alt = img.alt;
        gallery.querySelectorAll('.jas-gallery__thumb').forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
        if (counter) counter.textContent = index + 1 + ' / ' + total + ' · ' + (counter.dataset.suffix || '');
      });
    });

    var rail = gallery.querySelector('.jas-gallery__rail');
    if (rail) {
      var bars = gallery.querySelectorAll('.jas-gallery__bar');
      rail.addEventListener(
        'scroll',
        function () {
          var index = Math.round(rail.scrollLeft / rail.clientWidth);
          bars.forEach(function (bar, i) {
            bar.classList.toggle('active', i === index);
          });
        },
        { passive: true }
      );
    }
  });

  /* Hero slideshow — slow crossfade between slides; static under reduced motion. */
  document.querySelectorAll('[data-jas-hero-slides]').forEach(function (media) {
    var slides = media.querySelectorAll('.jas-hero__slide');
    if (slides.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var index = 0;
    setInterval(function () {
      index = (index + 1) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
    }, 6000);
  });

  /* Quantity steppers. */
  document.querySelectorAll('[data-jas-qty]').forEach(function (qty) {
    var input = qty.querySelector('input');
    if (!input) return;
    qty.querySelectorAll('button').forEach(function (button) {
      button.addEventListener('click', function () {
        var value = parseInt(input.value, 10) || 1;
        value += button.dataset.step === 'down' ? -1 : 1;
        input.value = Math.max(1, value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* Mobile sticky buy bar — appears once the buy card scrolls out of view,
     and replaces the site-wide call bar while visible. */
  var buybar = document.querySelector('.jas-buybar');
  var buycard = document.querySelector('[data-jas-buycard]');
  if (buybar && buycard && 'IntersectionObserver' in window) {
    var callbar = document.querySelector('.jas-callbar');
    new IntersectionObserver(
      function (entries) {
        var visible = !entries[0].isIntersecting;
        buybar.classList.toggle('visible', visible);
        if (callbar) callbar.style.display = visible ? 'none' : '';
      },
      { rootMargin: '-80px 0px 0px 0px' }
    ).observe(buycard);
  }
})();
